module.exports = __webpack_public_path__ + "static/media/edit.dfc21291.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit.svg
// module id = 1491
// module chunks = 1